import { mapActions, mapGetters } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        ...mapGetters({
            bursariesReceived: 'bursaries/Bursaries',
            bursaryReceived: 'bursaries/Bursary',
            bursaryFundingPaymentDetailsReceived: 'bursaries/BursaryFundingPaymentDetails',
            bursaryPaymentsReceived: 'bursaries/BursaryPayments',
        }),
    },
    methods: {
        ...mapActions({
            FetchBursaries: 'bursaries/FetchBursaries',
            FetchBursaryFundingPaymentDetailsByBursaryIDs: 'bursaries/FetchBursaryFundingPaymentDetailsByBursaryIDs',
            UpdateBursaryLearningAgreement: 'bursaries/UpdateBursaryLearningAgreement',
            FetchBursary: 'bursaries/FetchBursary',
            FetchBursaryFundingPaymentDetailsByBursaryID: 'bursaries/FetchBursaryFundingPaymentDetailsByBursaryID',
            FetchBursaryPaymentsByBursaryID: 'bursaries/FetchBursaryPaymentsByBursaryID',
        }),
        LoadBursaries() {
            eventBus.$emit('bursaries-fetch:started');
            this.FetchBursaries({ StudentID: this.student.StudentID })
                .then(() => {
                    this.bursaries = [...this.bursariesReceived];
                    eventBus.$emit('bursaries-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursaries-fetch:finished'));
        },
        LoadBursaryFundingPaymentDetailsByBursaryIDs(bursaryIDs) {
            eventBus.$emit('bursary-funding-payment-details-fetch:started');
            this.FetchBursaryFundingPaymentDetailsByBursaryIDs({ BursaryIDs: bursaryIDs })
                .then(() => {
                    this.bursaryFundingPaymentDetails = [...this.bursaryFundingPaymentDetailsReceived];
                    eventBus.$emit('bursary-funding-payment-details-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursary-funding-payment-details-fetch:finished'));
        },
        SaveBursaryLearningAgreement(id, learningAgreement) {
            eventBus.$emit('bursary-update-learning-agreement:started');
            this.UpdateBursaryLearningAgreement({ ID: id, LearningAgreement: learningAgreement })
                .then(() => eventBus.$emit('bursary-update-learning-agreement:success'))
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursary-update-learning-agreement:finished'));
        },
        ResetBursary() {
            this.bursary = {
                id: parseInt(this.$route.params.bursaryId) || 0,
                fkStudentID: 0,
            };
        },
        LoadBursary() {
            this.ResetBursary();

            if (this.bursary.id > 0) {
                eventBus.$emit('bursary-fetch:started');
                this.FetchBursary({ BursaryID: this.bursary.id, StudentID: this.student.StudentID })
                    .then(() => {
                        this.bursary = Object.assign({}, this.bursaryReceived);
                        eventBus.$emit('bursary-fetch:success');
                    })
                    .catch(error => eventBus.$emit('alert:error', error))
                    .finally(() => eventBus.$emit('bursary-fetch:finished'));
            } else eventBus.$emit('bursary-fetch:success');
        },
        LoadBursaryFundingPaymentDetailsByBursaryID() {
            eventBus.$emit('bursary-funding-payment-details-fetch:started');
            this.FetchBursaryFundingPaymentDetailsByBursaryID({ FKBursaryID: this.bursary.id })
                .then(() => {
                    this.bursaryFundingPaymentDetails = [...this.bursaryFundingPaymentDetailsReceived];
                    eventBus.$emit('bursary-funding-payment-details-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursary-funding-payment-details-fetch:finished'));
        },
        LoadBursaryPaymentsByBursaryID() {
            eventBus.$emit('bursary-payments-fetch:started');
            this.FetchBursaryPaymentsByBursaryID({ FKBursaryID: this.bursary.id })
                .then(() => {
                    this.bursaryPayments = [...this.bursaryPaymentsReceived];
                    eventBus.$emit('bursary-payments-fetch:success');
                })
                .catch(error => eventBus.$emit('alert:error', error))
                .finally(() => eventBus.$emit('bursary-payments-fetch:finished'));
        },
        GetBursaryStatusColor(status) {
            switch (status) {
                default: return 'info';
            }
        }
    },
};